import * as React from 'react';
import { LightboxElement, useLightboxReducer, LightboxActionType } from './use-lightbox-reducer';
import { LightboxDispatchContext } from './use-lightbox-dispatch/lightbox-dispatch.context';
import { LightboxStateContext } from './use-lightbox-state/lightbox-state.context';

export interface LightboxContextProps {
    initialIndex?: number;
    elements?: LightboxElement[];
    isLoopbackEnabled?: boolean;
    children?: React.ReactNode;
}

export function LightboxContextProvider({
    children,
    elements,
    initialIndex: index,
    isLoopbackEnabled = true,
}: LightboxContextProps): JSX.Element {
    const [state, dispatch] = useLightboxReducer({ elements, index, isLoopbackEnabled });
    React.useEffect(() => {
        dispatch({ payload: elements ?? [], type: LightboxActionType.SetElements });
    }, [elements, dispatch]);

    return (
        <LightboxDispatchContext.Provider value={dispatch}>
            <LightboxStateContext.Provider value={state}>{children}</LightboxStateContext.Provider>
        </LightboxDispatchContext.Provider>
    );
}
LightboxContextProvider.displayName = 'LightboxContextProvider';
